// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'POST',
    endpoint: '/api/ordini/:id/allegati',
    requestBody: '{"file":"File","nome":"string","note":"string?","visibileAcquirente":"boolean?"}',
    response: '{"success":true,"data":{"id":"number"}}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/ordini/:id/allegati/:allegatoId',
    requestBody: null,
    response: '{"success":true}'
  },
  {
    method: 'GET',
    endpoint: '/api/distinte?societaId&ordineId',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","numero":"number","tipo":"MERCE|LAVORAZIONI","addebito":"NOSTRO|CLIENTE","descrizione":"string|null","stato":"BOZZA|CONFERMATA","confermataAt":"string|null","_count":{"righe":"number"}}]}'
  },
  {
    method: 'POST',
    endpoint: '/api/distinte',
    requestBody: '{"ordineId":"number","tipo":"MERCE|LAVORAZIONI","righe":[{"rigaOrdineId":"number|null","componenteId":"number|null","articoloId":"number|null","descrizione":"string","quantita":"number","unitaMisura":"string|null","note":"string|null"}]}',
    response: '{"success":true,"data":{"id":"number","numero":"number"}}'
  },
  {
    method: 'GET',
    endpoint: '/api/ddt?societaId&ordineId',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","tipo":"VENDITA|CANTIERE","stato":"BOZZA|EMESSO|ANNULLATO","numero":"string|null","dataEmissione":"string|null","dataTrasporto":"string|null","clienteRagioneSociale":"string|null","_count":{"righe":"number"}}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/sal?societaId&ordineId',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","numero":"string|null","stato":"BOZZA|EMESSO|APPROVATO_CLIENTE|APPROVATO_BACKOFFICE|FATTURATO","dataEmissione":"string|null","importoTotale":"number","_count":{"righe":"number"}}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/ordini/:id',
    requestBody: null,
    response: '{"success":true,"data":{"ordine":"ricco","accontoPrevisto":"boolean","accontoTotaleFreeze":"string|null","proformeAcconto":"array"}}'
  },
  {
    method: 'POST',
    endpoint: '/api/proforme-acconto/rigenera-da-ordine/:ordineId',
    requestBody: null,
    response: '{"success":true,"data":{"proformaId":"number","numero":"string"}}'
  },
  {
    method: 'POST',
    endpoint: '/api/ordini/:id/conferma',
    requestBody: null,
    response: '{"success":true,"data":{"stato":"CONFERMATO","dataConferma":"string","modalitaEvasione":"DDT|MISTA"}}'
  },
  {
    method: 'POST',
    endpoint: '/api/ordini/:id/riporta-in-bozza',
    requestBody: null,
    response: '{"success":true,"data":{"stato":"BOZZA"}}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/ordini/:id',
    requestBody: null,
    response: '{"success":true,"data":{"preventivoRipristinato":{"id":"number","numero":"string"}|null}}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/ordini/:id/righe/:rigaId/contrattualizzazione',
    requestBody: null,
    response: '{"success":true}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
